import { render, staticRenderFns } from "./DistributionMailsView.vue?vue&type=template&id=49d72576&scoped=true"
import script from "./DistributionMailsView.vue?vue&type=script&lang=js"
export * from "./DistributionMailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d72576",
  null
  
)

export default component.exports